import { v4 as uuidv4 } from "uuid";
export class PAReviewMeetingModel {
    constructor() {
        this.id = uuidv4();
        this.reviewId = uuidv4();
        this.reviewMeetingName = "";
        this.reviewMeetingURL = "";
        this.reviewMeetingLocation = "";
        this.reviewMeetingNotes = "";
        this.reviewMeetingStatus = "";
        this.reviewMeetingStartTime = "";
        this.reviewMeetingEndTime = "";
        this.reviewMeetingDateAsString = "";
        this.reviewParticipants = [];
        this.reviewMeetingActionItems = [];
        this.canPerformMeetingOperation = false;
        this.canPerformMeetingDetailOperation = false;
        this.isMeetingStarted = false;
        this.isMeetingEnded = false;
        this.isClosed = false;
        this.canPerformNotesOperation = false;
        this.reviewMeetingActualStartDate = null;
        this.reviewMeetingActualEndDate = null;
        this.canShowNotes = false;
    }
}
export default class PAReviewMeeting extends PAReviewMeetingModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
